import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import Sidebar from "../components/Sidebar";
import { apiGet } from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
import { isEmpty } from "lodash";
import ReactPaginate from "react-paginate";
import helpers from "../utils/helpers";
import AuthContext from "../context/AuthContext";
import { isMobile } from "react-device-detect";
const Activitylog = () => {
  let { user, isLoader, setLoader } = useContext(AuthContext);
  const [getLogData, setLogData] = useState("");
  const [pageCount, setPageCount] = useState(0);
  const [search_params, setSearchParams] = useState({
    page: 1,
    limit: 100,
  });
  const myLogData = async () => {
    setLoader(true);
    const { status, data: response_users } = await apiGet(
      apiPath.activityLogs,
      search_params
    );
    if (status === 200) {
      if (response_users.success) {
        setLogData(response_users.results);
      }
    }
    setLoader(false);
  };
  const handlePageClick = (event) => {
    setSearchParams((prevState) => {
      return {
        ...prevState,
        page: event.selected + 1,
      };
    });
  };

  useEffect(() => {
    setPageCount(getLogData?.totalPages || []);
  }, [getLogData]);

  useEffect(() => {
    myLogData();
  }, [search_params]);
  return (
    <>
      {" "}
      <div className={isMobile ? "" : "main_wrap"}>
        <section className="main-inner-outer">
          <Container fluid>
            <div className="main_content_row">
              <Sidebar />

              <div className="mt-3 my_account_main">
                <div className="inner-wrapper">
                  <h2 className="common-heading">Account Statement</h2>

                  <section className="account-table">
                    <div className="profile-tab">
                      <div className="my_account_table_wrap">
                        <div className="table-main-wrapper">
                          <Table className="table_caption_style">
                            <thead>
                              <tr>
                                <th scope="col" className="text-start">
                                  Login Date & Time
                                </th>
                                <th scope="col" className="text-end">
                                  Login Status
                                </th>
                                <th scope="col" className="text-end">
                                  IP Address
                                </th>
                                <th scope="col" className="text-end">
                                  ISP
                                </th>
                                <th scope="col" className="text-end">
                                  City/State/Country
                                </th>
                                <th scope="col" className="text-end">
                                  User Agent Type
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {getLogData.data &&
                                getLogData.data.map((item, key) => (
                                  <tr key={key}>
                                    <td>
                                      {helpers.profileDate(
                                        item.activityDate,
                                        user.timeZone
                                      )}
                                    </td>
                                    <td>
                                      {" "}
                                      <span
                                        style={{ color: "#508d0e" }}
                                        className="text-end"
                                      >
                                        {item.activityStatus}
                                      </span>
                                    </td>
                                    <td className="text-end">{item.ip}</td>

                                    <td className="text-end">{item.isp}</td>
                                    <td className="text-end">{item.region}</td>
                                    <td  className="text-end w-25">
                                      {item.userAgent}
                                    </td>
                                  </tr>
                                ))}
                              {isEmpty(getLogData.data) ? (
                                <tr>
                                  <td colSpan={9}>No records found</td>
                                </tr>
                              ) : null}
                            </tbody>
                          </Table>
                          <div className="bottom-pagination">
                            <ReactPaginate
                              breakLabel="..."
                              nextLabel="Next"
                              onPageChange={handlePageClick}
                              pageRangeDisplayed={10}
                              pageCount={pageCount}
                              nextLabel="Prev"
                              renderOnZeroPageCount={null}
                              activeClassName="p-0"
                              activeLinkClassName="pagintion-li"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </Container>
        </section>
      </div>
    </>
  );
};

export default Activitylog;
